const linkPath1 = '<path d="M266.7 323.5 230.4 360a60 60 0 0 1-84.8-84.8l36.3-36.4-30.2-30.1-36.3 36.3A102.6 102.6 0 0 0 260.5 390l36.4-36.3-30.2-30.2z"/>';
const linkPath2 = '<path d="m245.3 175.3 36.3-36.3a60 60 0 0 1 84.8 84.8L330.1 260l30.2 30.2 36.3-36.3a102.6 102.6 0 1 0-145.1-145.1L215 145.1l30.2 30.2z"/>';
export const linkIcon = `
  <svg xmlns="http://www.w3.org/2000/svg"  viewBox="2 2 25 25">
    <g fill="none" fill-rule="evenodd">
      <g stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
        <path d="m16.209 19.18-1.704 1.704a3.81 3.81 0 0 1-5.389-5.39l1.704-1.703M13.791 10.82l1.704-1.704a3.81 3.81 0 0 1 5.389 5.389l-1.704 1.704M13.854 16.147l2.292-2.293"/>
      </g>
    </g>
  </svg>
`;
export const unlinkIcon = `<svg fill="currentColor" viewBox="0 0 512 512">${linkPath1}${linkPath2}</svg>`;
export const copyLinkIcon = linkIcon;
export const editLinkIcon = `<svg fill="currentColor" viewBox="0 0 24 24">
<path d="m20.4 5-1.3-1.4a2 2 0 0 0-2.9 0l-2.8 2.8L3 16.8V21h4.2l10.4-10.5 2.8-2.7c.8-.8.8-2 0-2.9zm-14 14H5v-1.4l9.8-9.8 1.4 1.4-9.8 9.9z"/>
</svg>`;
//# sourceMappingURL=icon.js.map